import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'De constante jeuk van mijn hond is volledig verdwenen. Binnen 3 weken zag ik al verschil. Had ik dit maar eerder geweten.',
    author: 'Amber',
    role: 'Hondentrainer bij Stressless Dogs'
  }, {
    quote: 'Mijn hond is zoveel rustiger sinds we zijn overgestapt. Ik dacht dat het gedrag was, maar het bleek de voeding. De onrust kwam letterlijk uit zijn darmen.',
    author: 'Klant',
    role: 'via Stressless Dogs'
  }, {
    quote: 'Na 8 weken Anifit: glanzende vacht, perfecte ontlasting, en mijn dierenarts vroeg wat ik anders doe. Dit is het bewijs dat voeding écht werkt.',
    author: 'Klant',
    role: 'via Stressless Dogs'
  }];
  return <section className="py-20 bg-white" data-id="element-209">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-211">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900" data-id="element-212">
            Als je eenmaal het verschil ziet ga je niet meer terug
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-213">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-50 p-8 rounded-2xl shadow-sm relative hover:shadow-md transition-shadow duration-300" data-id="element-214">
              <Quote className="w-10 h-10 text-[#4DBFB8]/20 absolute top-6 left-6" data-id="element-215" />
              <div className="relative z-10" data-id="element-216">
                <p className="text-gray-700 text-lg italic mb-6 pt-4" data-id="element-217">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-4" data-id="element-218">
                  <div className="w-12 h-12 bg-gray-200 rounded-full flex-shrink-0 overflow-hidden" data-id="element-219">
                    {/* Placeholder for avatar */}
                    <div className="w-full h-full bg-gradient-to-br from-gray-300 to-gray-400" data-id="element-220"></div>
                  </div>
                  <div data-id="element-221">
                    <p className="font-bold text-gray-900" data-id="element-222">
                      {testimonial.author}
                    </p>
                    <p className="text-sm text-[#4DBFB8] font-medium" data-id="element-223">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}